export default {
  gettext: (val: string): string => val,
};
